import { render } from "./ScrollComponent.vue?vue&type=template&id=60a5d715"
import script from "./ScrollComponent.vue?vue&type=script&lang=js"
export * from "./ScrollComponent.vue?vue&type=script&lang=js"

import "./ScrollComponent.vue?vue&type=style&index=0&id=60a5d715&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__